import { createSlice } from "@reduxjs/toolkit";

const firstTable = createSlice({
  name: "firstTable",
  initialState: [],
  reducers: {
    setFirstTable: (state, action) => {
      const { index, length, value } = action.payload;
      if (index !== undefined) {
        // Update individual index
        if (index >= 0 && index < state.length) {
          state[index] = value;
        }
      } else if (length !== undefined) {
        // Set initial state
        state.length = length;
        state.fill(value);
      }
    },
  },
});

export const { setFirstTable } = firstTable.actions;
export default firstTable.reducer;
